var progressTemplate = require("@/modules/components/share-overlay.handlebars");
import LogoIcon from "@/assets/media/icons/logo.svg";
import { DEVICE_TYPES } from "~/configs/constants";
import GlobalSettings from "~/core/global-settings";
import { stopPropagationTouchEvent, appendCommonStyling } from "~/helpers";

class ShareOverlay extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({ mode: "open" });
		this.logoIcon = LogoIcon;
		this.showingAlert = false;
	}

	getDataFromAttributes() {
		this.title = this.getAttribute("title");
		this.videoId = this.getAttribute("video-id");
		this.playlistId = this.getAttribute("playlist-id");
		this.currentIndex = this.getAttribute("data-index")
			? parseInt(this.getAttribute("data-index"))
			: 0;
		this.loop =
			this.getAttribute("loop") !== null &&
			this.getAttribute("loop") !== "false"
				? "true"
				: "false";
	}

	connectedCallback() {
		this.getDataFromAttributes();
		this.initial();
	}

	async initial() {
		const template = document.createElement("template");
		var context = {
			logoIcon: this.logoIcon,
			title: this.title,
		};
		template.innerHTML = `${progressTemplate(context)}`;
		await this.shadowRoot.appendChild(template.content.cloneNode(true));
		appendCommonStyling(this.shadowRoot);
		this.registerActions();
	}

	registerActions() {
		// Cancel btn
		const cancelBtn = this.shadowRoot.querySelector(".lora-share--cancel-btn");
		// Share btn
		const shareBtn = this.shadowRoot.querySelector(".lora-share--share-btn");

		// stop these events bubbling up the wrapper, and cause unexpected touch behaviors
		stopPropagationTouchEvent(cancelBtn);
		stopPropagationTouchEvent(shareBtn);

		cancelBtn.addEventListener("click", (event) => {
			event.stopPropagation();
			this.emitCloseShareEvent();
		});

		shareBtn.addEventListener("click", (event) => {
			event.stopPropagation();
			let urlShare = new URL(window.location.href);
			let params = {
				videoId: this.videoId,
			};
			if (this.playlistId) {
				params = {
					...params,
					current: this.currentIndex,
					loop: this.loop,
					playlistId: this.playlistId,
				};
			}
			let newUrlShare = this.updateSearchParam(urlShare, params);
			this.emitTriggerShareEvent(newUrlShare, params);

			if (
				GlobalSettings.getDevice() !== DEVICE_TYPES.DESKTOP &&
				navigator.share
			) {
				navigator
					.share({
						title: "Share now",
						text: newUrlShare,
					})
					.catch(console.error);
			} else if (navigator.clipboard) {
				let inputShare = this.shadowRoot.querySelector(".lora-share--input");
				inputShare.style.display = "block";
				inputShare.value = newUrlShare;

				/* Select the text field */
				inputShare.select();
				inputShare.setSelectionRange(0, 99999); /* For mobile devices */
				try {
					/* Copy the text inside the text field */
					navigator.clipboard.writeText(inputShare.value);
					inputShare.style.display = "none";
					this.showShareSuccessAlert();
					return true;
				} catch (error) {
					console.error("Oops, unable to copy", err);
				}
				inputShare.style.display = "none";
				this.showShareSuccessAlert();
				return false;
			}
		});

		// CLick outsite close share layout
		this.shadowRoot
			.querySelector(".lora-share__alert")
			.addEventListener("click", (e) => {
				e.stopImmediatePropagation();
				if (this.showingAlert) {
					this.emitCloseShareEvent();
					this.shadowRoot
						.querySelector(".lora-share__main")
						.classList.remove("lora--d-none", "lora--hidden");
					this.shadowRoot
						.querySelector(".lora-share__alert")
						.classList.remove("lora--flex-center");
				}
			});
	}

	emitCloseShareEvent() {
		this.shadowRoot.dispatchEvent(
			new CustomEvent("share-cancel", {
				composed: true,
				bubbles: true,
			})
		);
	}

	emitTriggerShareEvent(url, params) {
		this.shadowRoot.dispatchEvent(
			new CustomEvent("shared", {
				detail: {
					url: url,
					...params,
				},
				composed: true,
				bubbles: true,
			})
		);
	}

	// Here it is as a function that accepts (URL, Record<string, string>)
	updateSearchParam(url, params = {}) {
		for (const param in params) {
			url.searchParams.set(param, params[param]);
		}
		let newUrl = new URL(
			`${url.origin}${url.pathname}?${url.searchParams.toString()}`
		);
		return newUrl.href;
	}

	showShareSuccessAlert() {
		/* Alert the copied text */
		this.shadowRoot
			.querySelector(".lora-share__main")
			.classList.add("lora--d-none", "lora--hidden");
		this.shadowRoot
			.querySelector(".lora-share__alert")
			.classList.add("lora--flex-center");
		this.showingAlert = true;
		setTimeout(() => {
			this.emitCloseShareEvent();
			this.shadowRoot
				.querySelector(".lora-share__main")
				.classList.remove("lora--d-none", "lora--hidden");
			this.shadowRoot
				.querySelector(".lora-share__alert")
				.classList.remove("lora--flex-center");
			this.showingAlert = false;
		}, 1000);
	}
}
window.customElements.define("b-overlay", ShareOverlay);
